<template>
  <div v-if="$store.state.me.role !== 'partner'" class="lsg-cabinet">
    <div class="main__header">
      <div class="main__header__item left"></div>
      <div class="main__header__item">
        <h1>{{ title }}</h1>
      </div>
      <div class="main__header__item right"></div>
    </div>
    <div class="main__content">
      <div v-if="isLoading" class="spinner__container">
        <Spinner/>
      </div>
      <form class="lk" autocomplete="off" @submit.prevent="saveCompany">
        <div class="lk__inputs">
          <div v-if="!disabled" class="lk__field">
            <label>Ответственный:</label>
            <VSelectQuery
              key-value="id"
              entity-getter="allUsers"
              :value="fields.responsible_user_id"
              @input="onUserChange"
              select-width="100%"
            />
          </div>
          <div class="lk__field">
            <label for="name">Наименование:</label>
            <input type="text" v-model="fields.name" id="name">
          </div>
          <div class="lk__field">
            <label>Теги:</label>
            <VSelectQuery
              placeholder="Выберите тэги"
              entity-name="allTags"
              key-value="id"
              select-width="100%"
              multiple
              @input="($event) => fields.tags = $event.map(item => item.id)"
            />
          </div>
          <div class="lk__field">
            <label for="email">E-mail:</label>
            <input type="email" id="email" v-model="fields.email">
          </div>
          <div class="lk__field">
            <label for="inn">ИНН:</label>
            <input type="text" id="inn" v-model="fields.inn" @input="onInnInput">
          </div>
          <div class="lk__field">
            <label for="type">Вид:</label>
            <VSelectQuery
              key-name="label"
              :entity-getter="() => companyTypeOptions"
              :value="fields.typeValue"
              @input="onTypeChange"
              select-width="100%"
            />
          </div>
          <div class="lk__field">
            <label>Телефоны:</label>
            <div class="phones">
              <div class="phones__item" v-for="(phone, index) in fields.phones" :key="index">
                <div class="phones__phone">
                  <input type="text" v-model="phone.value">
                </div>
                <div class="small-buttons">
                  <button class="btn btn--small" type="button" v-if="index !== 0" @click="removePhone($event, index)">
                    <MinusIco/>
                  </button>
                  <button class="btn btn--small" type="button" @click="addPhone">
                    <PlusIco/>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button type="submit" class="btn">ДОБАВИТЬ</button>
        </div>
        <div class="lk__back">
          <CompanyBack/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CompanyBack from '@/components/svg/CompanyBack'
import PlusIco from '@/components/svg/plus'
import MinusIco from '@/components/svg/minus'
// import MAKE_CALL from '@/graphql/mutations/MakeCall.gql'
import ADD_COMPANY from '@/graphql/mutations/AddCompany.gql'
import GraphQLHelper from '@/helpers/GraphQLHelper'
import callPhoneHelper from '@/helpers/callPhone'
import VSelectQuery from '@/components/ui/select/components/VSelectQuery.vue'
import Spinner from '@/components/svg/spinner.vue'

const _graphQlHelper = new GraphQLHelper()

export default {
  name: 'AddCompany',
  components: {
    Spinner,
    VSelectQuery,
    MinusIco,
    PlusIco,
    CompanyBack
  },
  props: {
    isModalMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: 'Добавить компанию',
      disabled: true,
      fields: {
        name: '',
        email: '',
        responsible_user_id: '',
        responsible_user_name: '',
        typeValue: null,
        typeName: null,
        inn: '',
        group_id: '',
        phones: [
          {
            value: ''
          }],
        tags: []
      },
      isLoading: false,
      companyTypeOptions: [
        { label: 'Юридическое лицо', value: 'ЮридическоеЛицо' },
        { label: 'Индивидуальный предприниматель', value: 'ИндивидуальныйПредприниматель' },
        { label: 'Самозанятый', value: 'Самозанятый' },
        { label: 'Физическое лицо', value: 'ФизическоеЛицо' }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$store.state.loadedPages.push({ title: this.$route.meta.title, route: this.$route.name })
    })
  },
  created () {
    this.fields.responsible_user_id = this.$store.state.me._id
    this.fields.responsible_user_name = this.$store.state.me.name
    this.disabled = this.$store.state.me.role === 'manager'
  },
  methods: {
    getCurrentPhone () {
      let currentPhones = []

      this.fields.phones.forEach(phone => {
        if (phone.value) {
          currentPhones.push(phone.value)
        }
      })

      return currentPhones
    },
    saveCompany () {
      this.$data.isLoading = true

      let currentInput = {
        name: this.fields.name,
        email: this.fields.email,
        inn: this.fields.inn,
        group_id: this.fields.group_id,
        responsible_user_id: this.fields.responsible_user_id,
        phone: this.getCurrentPhone(),
        tags: this.fields.tags,
        type: this.fields.typeValue
      }

      this.$apollo.mutate({
        mutation: ADD_COMPANY,
        variables: {
          input: currentInput
        },
        update: (store, { data }) => {
          if (data && data.addCompany && data.addCompany._id) {
            this.$notify({
              group: 'lsg-notify',
              text: 'Контрагент успешно создан'
            })
            if (this.$props.isModalMode) {
              this.$emit('company-сreated')
            } else {
              this.$router.push({ path: `/companies/${data.addCompany._id}` })
            }

            setTimeout(() => {
              this.$data.isLoading = false
            }, 1500)
          }
        }
      }).catch(error => {
        _graphQlHelper.graphQLErrorMessages(error).forEach(item => {
          this.$notify({
            group: 'lsg-notify',
            text: item
          })
          if (!/Данный ИНН зарегистрирован у пользователя/.test(item)) {
            this.$notify({
              group: 'lsg-notify-support',
              title: 'Сообщить в поддержку',
              text: `Нажав на это сообщение, вы отправите отчёт об ошибке в тех.поддержку`,
              type: 'info',
              closeOnClick: true,
              data: {
                info: {
                  project: 'Личный кабинет Leasing-trade',
                  name: this.$store.state.me.name,
                  email: this.$store.state.me.email,
                  group_id: this.$store.state.me.group.id,
                  role: this.$store.state.me.role,
                  localTime: new Date(),
                  system: navigator.userAgent,
                  url: window.location.href,
                  window: `${window.window.screen.availWidth}px ${window.window.screen.availHeight}px`,
                  error: item,
                  comment: 'Ошибка при создании компании'
                },
                style: 'cursor: pointer'
              }
            })
          }
        })

        setTimeout(() => {
          this.$data.isLoading = false
        }, 1500)
      })
    },
    addPhone () {
      this.fields.phones.push({ value: '' })
    },
    removePhone (e, index) {
      e.preventDefault()

      this.fields.phones.splice(index, 1)
    },
    async callPhone (phone) {
      if (!phone || !this.$store.state.me.workphone) {
        this.$notify({
          group: 'lsg-notify',
          text: 'Не указан телефон'
        })
        return
      }
      await callPhoneHelper(this, phone)
    },
    onInnInput () {
      if (this.fields.inn.length === 10) {
        this.fields.typeValue = this.companyTypeOptions[0].value
        this.fields.typeName = this.companyTypeOptions[0].label
      } else if (this.fields.inn.length === 12) {
        this.fields.typeValue = this.companyTypeOptions[1].value
        this.fields.typeName = this.companyTypeOptions[1].label
      }
    },
    onUserChange (e) {
      if (e) {
        this.fields.responsible_user_id = e.user_id
        this.fields.responsible_user_name = e.name
      } else {
        this.fields.responsible_user_id = null
        this.fields.responsible_user_name = null
      }
    },
    onTypeChange (e) {
      if (e) {
        this.fields.typeValue = e.value
        this.fields.typeName = e.label
      } else {
        this.fields.typeValue = null
        this.fields.typeName = null
      }
    }
  }
}
</script>
